import { render, staticRenderFns } from "./couponGiveReceiveEdit.vue?vue&type=template&id=b2fa6070&"
import script from "./couponGiveReceiveEdit.vue?vue&type=script&lang=js&"
export * from "./couponGiveReceiveEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports